<div id="cover" *ngIf="projectService.loading()"></div>



<div class="col-md-12 text-end mb-2">
    <button name="add" type="button" class="btn-primary-save" (click)="addMaster()">
        <i class="fa fa-plus" title="Add"></i> Add New Master
    </button>
</div>
<div class="section-page dashboard">
    <div [ngClass]="rowData.length == 0 ? 'no-data-found' : 'container-fluid' ">
        <ag-grid-angular *ngIf="rowData.length > 0" class="ag-theme-alpine" [rowData]="rowData"
            [columnDefs]="columnDefs" [defaultColDef]="defaultColDef" (gridReady)="onGridReady($event)"
            (firstDataRendered)="onFirstDataRendered($event)" [pagination]="true" style="height: 100%; width: auto;">
        </ag-grid-angular>
        <div *ngIf="rowData.length == 0">
            <img src="../../assets/img/no-data.png">
        </div>
    </div>
</div>

<p-dialog header="Master Details" [(visible)]="commonDataObject.displayDialog" [modal]="true"
    [style]="{ width: '650px' }" (onHide)="cancel()">
    <form [formGroup]="masterForm">
        <div class="row">
            <div class="col-md-4">
                <label class="col-form-label">Master Type <font color="red">*</font></label>
                <p-select formControlName="master_type_name" [options]="projectService.getMasterTypes()"
                    optionLabel="master_type_name" placeholder="None Selected" [resetFilterOnHide]="true"
                    [style]="{ width: '100%' }" appendTo="body" [editable]="true">
                </p-select>
            </div>
            <div class="col-md-4">
                <label class="col-form-label">Master Name <font color="red">*</font></label>
                <input type="text" pInputText formControlName="master_value_name" />
            </div>
            <div class="col-md-4">
                <div class="row align-items-center">
                    <div class="col-md-8 mt-4">
                        <input type="checkbox" formControlName="is_remark">
                        <label class="label ms-2 mb-0">Add Remark</label>
                    </div>
                    <div class="col-md-4">
                        <label class="col-form-label">Status</label><br />
                        <p-toggleSwitch id="is_active" formControlName="is_active"></p-toggleSwitch>
                    </div>
                </div>
            </div>
        </div>

        <hr />

        <div class="d-flex justify-content-between align-items-center mb-2">
            <h6><b>Sub Master Details</b></h6>
            <button type="button" class="btn-primary-save" (click)="addSubMaster()">
                <i class="fa fa-plus" title="Add"></i> Add Sub Master
            </button>
        </div>
        <div formArrayName="sub_master_values_details">
            <div class="row align-items-center mb-2" *ngFor="let sub of subMasters.controls; let i = index"
                [formGroupName]="i">
                <div class="col-md-4">
                    <input type="text" pInputText placeholder="Sub Master Name"
                        formControlName="sub_master_value_name" />
                </div>
                <div class="col-md-2 d-flex justify-content-center">
                    <p-toggleSwitch id="is_active" formControlName="is_active"></p-toggleSwitch>
                </div>
                <div class="col-md-3">
                    <button type="button" class="btn btn-sm btn-danger" (click)="removeSubMaster(i)">
                        <i class="fa fa-trash" title="Add"></i>
                    </button>
                </div>
            </div>
        </div>
    </form>
    <ng-template pTemplate="footer">
        <button class="btn-cancel-secondary" (click)="cancel()">Close</button>
        <button class="btn-primary-save" [disabled]="masterForm.invalid" (click)="saveMasterData()">
            Save
        </button>
    </ng-template>
</p-dialog>

<p-dialog header="Delete Master" [(visible)]="commonDataObject.deleteDialog" [modal]="true" [closable]="true"
    [style]="{width: '600px'}">
    <div class="row">
        <div class="col-md-12">
            Are you sure you want to delete this Master?
        </div>
    </div>
    <ng-template pTemplate="footer">
        <button type="button" class="btn-cancel-secondary" label="Show" styleClass="p-button-text"
            (click)="commonDataObject.deleteDialog = false">
            Cancel
        </button>
        <button type="button" class="btn-danger-delete" label="Show" (click)="saveMasterData('Delete')"
            styleClass="p-button-text">
            Delete
        </button>
    </ng-template>
</p-dialog>

<div class="alert-message" [class.show]="commonDataObject.issuccessAlert || commonDataObject.iserrorAlert"
    [class.success]="commonDataObject.issuccessAlert" [class.error]="commonDataObject.iserrorAlert">
    <i class="fas" [class.fa-check-circle]="commonDataObject.issuccessAlert"
        [class.fa-exclamation-circle]="commonDataObject.iserrorAlert"></i>
    <span>{{ commonDataObject.apiMeassge }}</span>
    <i class="fas fa-times close-alert"
        (click)="commonDataObject.issuccessAlert = false; commonDataObject.iserrorAlert = false"></i>
</div>